import React from "react";
import { Sparkles } from "lucide-react";

// Jednotná animace "AI tvoří" s progresem 0-100 %. Záměrně žádné texty okolo:
// jen jiskřící orb, velké procento a plynulý gradientní pruh.
// Používá se u generování jídelníčku (detail klienta) i PDF jídelníčků.
export default function AIGenerating({ pct = 0 }) {
  const p = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div className="w-full py-1">
      <div className="flex items-center gap-3">
        <div className="relative w-10 h-10 shrink-0">
          <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-brand-500 via-fuchsia-500 to-amber-400 animate-spin [animation-duration:2.4s] opacity-80 blur-[6px]" />
          <div className="absolute inset-[3px] rounded-full bg-white flex items-center justify-center shadow-sm">
            <Sparkles className="w-5 h-5 text-brand-600 animate-pulse" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-2xl font-extrabold text-brand-700 tabular-nums leading-none mb-1.5">{p} %</div>
          <div className="h-2.5 bg-brand-100/70 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full bg-gradient-to-r from-brand-500 via-fuchsia-500 to-brand-500 bg-[length:200%_100%] animate-[aigen_1.6s_linear_infinite] transition-[width] duration-700"
              style={{ width: `${Math.max(3, p)}%` }}
            />
          </div>
        </div>
      </div>
      <style>{`@keyframes aigen { 0% { background-position: 0% 0; } 100% { background-position: 200% 0; } }`}</style>
    </div>
  );
}

// Odhad procent, když backend ještě neposlal reálný progress: plynule roste
// podle času k ~95 % (dojetí na 100 % zajistí reálný stav "hotovo").
export function odhadPct(startMs, ocekavaneSekundy = 150) {
  if (!startMs) return 5;
  const elapsed = (Date.now() - startMs) / 1000;
  return Math.min(95, 5 + (elapsed / ocekavaneSekundy) * 90);
}
